<template>
  <div class="sb-card__footer">
    <slot></slot>
  </div>
</template>
<script lang="ts">
export default {
  name: 'SbCardFooter',
}
</script>
